import { PopoverCollisionTopInsetContext } from '#pplx/frontend/aether/internal/popover-collision/context.js';
import { useContext, useMemo } from 'react';
function toRect(padding) {
    if (typeof padding === 'number') {
        return { top: padding, right: padding, bottom: padding, left: padding };
    }
    return {
        top: padding.top ?? 0,
        right: padding.right ?? 0,
        bottom: padding.bottom ?? 0,
        left: padding.left ?? 0,
    };
}
/** Viewport-relative top of the region a surface's popovers are clipped to. */
function clippingTop(boundary) {
    const elements = (Array.isArray(boundary) ? boundary : [boundary]).filter((element) => element != null);
    // Boundaries intersect, and the viewport is always among them, so the most
    // restrictive top wins.
    return elements.reduce((top, element) => Math.max(top, element.getBoundingClientRect().top), 0);
}
export function useCollisionPaddingWithTopInset(padding = 0, collisionBoundary) {
    const topInset = useContext(PopoverCollisionTopInsetContext) ?? 0;
    const { top, right, bottom, left } = toRect(padding);
    // Padding is measured from the clipping region's top, which is a surface's own
    // top when it supplies one as the boundary. Only the part of the chrome that
    // overlaps that region is worth reserving: a surface laid out below the chrome
    // needs none, one pinned to the viewport top needs all of it.
    // With no reserved chrome the boundary cannot overlap it. Avoid forcing a
    // layout on every render, including for closed overlays during streaming.
    const overlap = topInset > 0 ? Math.max(0, topInset - clippingTop(collisionBoundary)) : 0;
    return useMemo(() => ({ top: top + overlap, right, bottom, left }), [top, right, bottom, left, overlap]);
}
//# sourceMappingURL=useCollisionPaddingWithTopInset.js.map